<template lang='html'>
  <section class='g-share-pop-layout'  v-if="visible">
    <div  class="modal-mask-background" @touchstart.prevent @touchmove.prevent></div>
    <div class="drawing" v-if="posterType==0" @touchstart.prevent @touchmove.prevent>
      <img :src="`${baseUrl}static/imgs/icon-loading.png`"/>
      <p class="text">海报生成中…</p>
    </div>
    <div class="poster-content" v-if="posterType==2" @touchstart.prevent @touchmove.prevent>
      <img :src="imgBase64"/>
    </div>
    <div class="drawing" v-if="posterType==1" @click.stop="drawPicHandlerImg">
      <img :src="`${baseUrl}static/imgs/icon-reload.png`"/>
      <p class="text">网络开小差了，点击重试</p>
    </div>
    <div class="share-wrapper" v-if="posterType!=0&&posterType!=1" @touchmove.prevent>
      <div class="share-title" v-if="posterType==2">分享当前图片到</div>
      <div class="share-title" v-else>分享到</div>
      <div class="share-list" v-if="!showCopy">
        <div class="icon-wrapper" @click.stop="share(item)" v-for="(item,index) in showShareType" :key="index" :ref="item==5?'btn':''" :data-clipboard-text="clipboardText(item)" >
          <img :src="`${baseUrl}static/imgs/icon-${item.key}.png`">
          <p class="text">{{item.text}}</p>
        </div>
      </div>
      <div class="copy-ui" v-if="showCopy">
          <img :src="`${baseUrl}static/imgs/icon-success.png`"/>
          <h1 class="link-title">链接已复制成功，快去粘贴吧～</h1>
      </div>
      <h1 class="title" @click.stop="closePopup" > {{showCopy ? '确定' : '取消'}}</h1>
    </div>
    <div id="qrcode" ref="qrcode" v-if="showCode"></div>
  </section>
</template>

<script>
import TjCanvas from '@tujia/fe_canvas_tool'
import appBridge from '@lib/business/tjShare/appBridge.js'
import { dataURLtoFile } from '@/utils/tj_canvas.js'
import { upload } from '@/services/upload.js'
import { getQRcode } from '@/services/promotion'
import QRCode from 'qrcodejs2'
import { Toast as ToastUI } from '@tujia/tj-mob-ui'
import Clipboard from 'clipboard'
import urlHelper from '@lib/utils/urlHelper'
const showShareType = [
  { id: 4, text: '生成分享图', key: 'erweima' },
  { id: 1, text: '微信', key: 'wechat' },
  { id: 2, text: '朋友圈', key: 'circle' }
]

export default {
  watch: {
    popOptions: {
      handler(n, o) {
        if (n) {
          this.$nextTick(() => {
            if (this.$refs.btn && this.$refs.btn[0]) {
              this.clipboard = new Clipboard(this.$refs.btn[0])
            }
          })
        }
      },
      deep: true
    }
  },
  data() {
    return {
      visible: false,
      popOptions: {},
      // 支持的分享类型
      // [
      //   { id: 1, text: '微信', key:'wechat' },
      //   { id: 2, text: '朋友圈', key:'circle' },
      //   { id: 3, text: '微博', key:'weibo' },
      //   { id: 4, text: '生成分享图', key:'erweima' },
      //   { id: 5, text: '复制链接', key:'link' },
      //   { id: 6, text: '保存到相册', key:'saveImg' }
      // ]
      showShareType,
      // 展示ui
      showCopy: false,
      // 复制
      clipboard: '',
      showCode: true,
      // 海报状态:0,默认生成图片中 1,生成失败 2,上传成功
      posterType: -1,
      // 分享的模版
      shareModelChoosed: [
        {
          type: 'wrap',
          width: 750,
          height: 1334
        },
        {
          // banner背景
          type: 'image',
          url: '',
          x: 0,
          y: 0,
          width: 750,
          height: 1334
        },
        {
          // 7二维码
          type: 'image',
          url: '',
          x: 467,
          y: 1045,
          width: 220,
          height: 220
        }
      ]
    }
  },
  created() {
    const queryObjs = urlHelper.queryStrings()
    this.promotionId = queryObjs.id
  },
  methods: {
    /**
     * 复制的文案
     */
    clipboardText(item) {
      let urlobj = urlHelper.getQueryStringByStringUrl(window.location.href)
      if (urlobj.tjuserid || urlobj.tjusertoken || urlobj.mref) {
        delete urlobj.tjuserid
        delete urlobj.tjusertoken
        delete urlobj.mref
      }
      // console.log(urlHelper.getStringByObject(urlobj))
      let url = window.location.origin + window.location.pathname + (urlHelper.getStringByObject(urlobj) ? '?' : '') + urlHelper.getStringByObject(urlobj)
      console.log(url)
      return item === 5 ? url : ''
    },
    /**
     * 点击分享按钮
     * @param {String} tab 分享项
     */
    share(tab) {
      if (this.posterType === 2) {
        this.shareCallbackImg(tab)
      } else if (tab.id === 5) {
        this.clipboard && this.clipboard.on('success', (e) => {
          e.clearSelection()
          this.showCopy = true
          this.shareCallback(tab)
        })
        this.clipboard && this.clipboard.on('error', (e) => {
          // 复制失败
        })
      } else {
        this.shareCallback(tab)
      }
    },
    /**
     * 关闭分享弹层
     */
    closePopup() {
      this.posterType = -1
      this.showCopy = false
      this.visible = false
      this.showShareType = showShareType
    },
    showPopup(opts) {
      this.shareInfo = opts
      this.visible = true
    },
    /**
     * 复制对象销毁
     */
    destroyed() {
      this.clipboard && this.clipboard.destroy()
    },
    /**
     * 分享
     * @param {Number} 分享类型
     * ********   弹框只有途家做了适配 故里面弹框里面的事件默认为途家平台，未对里面的点击行为做平台区分适配   ******
     */
    shareCallback(tab) {
      const shareType = tab.id
      // 分享类型    1: 'wechat'  2: 'circle'  3: 'weibo'   4: 'erweima'  5: 'link'
      if (shareType === 1) {
        this.appShare(-2)
      } else if (shareType === 2) {
        this.shareCirleUrl ? this.appShare(-1) : this.drawPicHandler(shareType)
      } else if (shareType === 3) {
        this._shareWeibo()
      } else if (shareType === 4) {
        this.posterType = 0
        // 画当前页面海报
        if (!this.posterImgUrl) {
          this.drawPicHandlerImg()
        } else {
          this.posterType = 2
          this.showShareType = [
            { id: 1, text: '微信', key: 'wechat' },
            { id: 2, text: '朋友圈', key: 'circle' },
            { id: 6, text: '保存到相册', key: 'saveImg' }
          ]
        }
      } else if (shareType === 5) {
      // nothing todo
      }
      window._fas && window._fas.setCustomTrack({
        eventname: 'C_HOME_CMS_SHARE_TO_CLICK',
        ext: {
          button: tab.text,
          rank_list_id: this.promotionId,
          rank_list_name: document.title,
          share_type: shareType === 4 ? 2 : 1
        }
      })
    },
    /**
     * 获取二维吗画图
     */
    async drawPicHandler(shareType) {
      this.$loading(true)
      let haveGoLink = this.shareInfo.goLink
      this.qrCode = haveGoLink ? await getQRcode(this.shareInfo.goLink) : this.drawQrCode()
      if (this.qrCode) {
        this.shareModelChoosed[1].url = this.shareInfo.timelineImg
        this.shareModelChoosed[2].url = haveGoLink ? `data:image/jpg;base64,` + this.qrCode.replace(/\n/g, '') : this.qrCode
        var myCanvas = new TjCanvas({
          domID: 'canvas',
          drawJson: this.shareModelChoosed,
          isFitScreen: false
        })
        myCanvas
          .draw()
          .then(() => {
            this.base64 = myCanvas.toBase64Image()
            // 分享类型    1: 'wechat'  2: 'circle'  3: 'weibo'   4: 'erweima'  5: 'link'
            if (shareType === 1 || shareType === 2) {
              // 需要上传操作
              this._shareCircleApp()
            }
          })
          .catch((errCode) => {
            console.log(errCode)
            // 错误类型可参考http://fedoc.corp.tujia.com/fe_canvas_tool_doc/
            this.msg = `暂时无法生成海报，请稍后尝试！,错误类型：${errCode}`
            this.showToast = true
            this.$loading(false)
          })
      } else {
        this.msg = '数据获取异常，请稍后重试'
        this.showToast = true
        this.$loading(false)
      }
    },
    // 海报分享
    billShare(type) {
      // -2 好友列表 -1 朋友圈
      let sharedChannel = type
      let title = this.shareInfo.shareTitle
      let content = ''
      let imgUrl = this.posterImgUrl
      let currentUrl = ''
      appBridge.shareInApp(
        currentUrl,
        title,
        content,
        content + currentUrl,
        imgUrl,
        sharedChannel,
        '',
        '',
        (res) => {
          this.closePopup()
          console.log('分享状态=' + res)
        },
        false,
        ''
      )
    },
    /**
     * app分享
     */
    appShare(shareType) {
      this.$loading(false)
      // -2 好友列表 -1 朋友圈
      let sharedChannel = shareType
      let title = this.shareInfo.title
      let content = ''
      let imgUrl = shareType === -1 ? this.shareCirleUrl : this.shareInfo.imageUrl
      const url = this.shareInfo.link
      let currentUrl = shareType === -1 ? '' : url
      let shareUrlForWeChatSmallApp = `/pages/webview/index?h5url=${encodeURIComponent(url)}`
      let miniProgramType = process.env.VUE_APP_MINI_PROGRAM_TYPE
      appBridge.shareInApp(
        currentUrl,
        title,
        content,
        content + currentUrl,
        imgUrl,
        sharedChannel,
        shareUrlForWeChatSmallApp,
        miniProgramType,
        (res) => {
          this.closePopup()
          console.log('分享状态=' + res)
        },
        false,
        ''
      )
    },
    /**
     * 在app的分享图片
     */
    async _shareCircleApp() {
      this.codeFile = dataURLtoFile(this.base64, 'codeFile')
      this.shareCirleUrl = await upload(this.codeFile)
      if (this.shareCirleUrl) {
        this.appShare(-1)
      } else {
        this.$loading(false)
        this.msg = '上传图片失败，请稍后重试'
        this.showToast = true
      }
    },
    /**
     * 分享微博
     */
    _shareWeibo() {
      let title = this.shareInfo.normalShare.shareTitle
      let weiboUrl = this.picHost + this.shareInfo.normalShare.shareImg
      window.location.href = `http://service.weibo.com/share/share.php?url=${encodeURIComponent(this.shareInfo.link)}&sharesource=weibo&title=${title}&pic=${weiboUrl}`
    },
    // 分享当前图片到
    shareCallbackImg(tab) {
      const shareType = tab.id
      window._fas && window._fas.setCustomTrack({
        eventname: 'C_HOME_CMS_SHARE_PICTURE_CLICK',
        ext: {
          button: tab.text,
          rank_list_id: this.promotionId,
          rank_list_name: document.title
        }
      })

      if (shareType === 1) { // 微信
        this.billShare(-2)
      } else if (shareType === 2) { // 朋友圈
        this.billShare(-1)
      } else if (shareType === 6) { // 保存到相册
        window.tjBridge.saveImage({
          imgUrl: this.posterImgUrl,
          success: (res) => {
            ToastUI('保存成功')
            this.closePopup()
          },
          fail: () => {
            ToastUI('保存失败，请重试！')
          },
          final: () => {}
        })
      }
    },
    // 生成二维码-当前h5页面
    drawQrCode() {
      let long = document.documentElement.clientWidth * (67 / 375)
      if (!this.base64Text) {
        let code = new QRCode(document.getElementById('qrcode'), {
          text: this.shareInfo.link,
          width: long,
          height: long,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.H
        })
        let canvas = code._el.querySelector('canvas')
        let base64Text = canvas.toDataURL('image/jpeg')
        this.showCode = false
        return base64Text
      } else {
        return this.base64Text
      }
    },
    // 生成海报
    async drawPicHandlerImg() {
      this.base64Text = this.drawQrCode()
      if (this.base64Text) {
        this.shareModelChoosed[1].url = this.shareInfo.timelineImg
        this.shareModelChoosed[2].url = this.base64Text
        var myCanvas = new TjCanvas({
          domID: 'canvas',
          drawJson: this.shareModelChoosed,
          isFitScreen: false
        })
        myCanvas
          .draw()
          .then(() => {
            this.imgBase64 = myCanvas.toBase64Image()
            this.uploadBill()
          })
          .catch((errCode) => {
            // 错误类型可参考http://fedoc.corp.tujia.com/fe_canvas_tool_doc/
            this.posterType = 1
            console.log('errCode', errCode)
          })
      } else {
        this.posterType = 1
      }
    },
    // 上传海报
    async uploadBill() {
      let codeFile = dataURLtoFile(this.imgBase64, 'codeFile')
      try {
        this.posterImgUrl = await upload(codeFile) || ''
        if (this.posterImgUrl) {
          this.posterType = 2
          this.showShareType = [
            { id: 1, text: '微信', key: 'wechat' },
            { id: 2, text: '朋友圈', key: 'circle' },
            { id: 6, text: '保存到相册', key: 'saveImg' }
          ]
        } else {
          this.posterType = 1
        }
      } catch (e) {
        this.posterType = 1
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.g-share-pop-layout {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  transition: opacity .3s ease;
  z-index: 114;
  .modal-mask-background{
   position: absolute;
   bottom: 0;
   height: 100vh;
   width: 100vw;
   background-color: rgba(0, 0, 0,.7);
   z-index: 998;
  }
  .share-wrapper {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    text-align: center;
    background-color: #fff;
    z-index: 999;
    border-radius: 12px 12px 0px 0px;
    .share-title {
      margin-top: 1.5vh;
      font-family: PingFangSC-Medium;
      font-size: 18px;
      line-height: 25px;
      color: #333333;
      text-align: center;
      font-weight: bold;
    }
    .title {
      padding: 3vh 0;
      margin: 0 4vh;
      border-top: 0.5px solid #D8D8D8;
      font-size: 20px;
      color: #797979;
      text-align: center;
    }
    .icon-wrapper{
      width: 35vw;
    }
    .share-list {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 5vh  0  4vh 0 ;
      img{
        width: 16vw;
        height: 16vw;
      }
      .text {
        margin-top: 6px;
        font-size: 12px;
        color: #797979;
      }
    }
    .copy-ui{
      padding: 7vh 0 7vh 0 ;
      .link-title{
        font-size: 14px;
        color: #9B9B9B;
      }
      img{
        width: 23px;
        height: 23px;
        margin-bottom: 11px;
      }
    }
  }
  .drawing {
    width: 100%;
    position: absolute;
    top: 30.5vh;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    z-index: 999;
    img {
      width: 5.3vw;
    }
    .text {
      font-family: PingFangSC-Regular;
      font-size: 14px;
      line-height: 5.2vw;
      color: #FFFFFF;
      line-height: 18px;
    }
  }
  .poster-content {
    width: 100%;
    position: absolute;
    text-align: center;
    z-index: 999;
    display: flex;
    justify-content: center;
    img {
      width: 32.65vh;
      margin-top: 2.7vh;
    }
  }
}
</style>
